import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { Payment } from '../loan/Payments';
import { BaseLoanEvent } from './BaseLoanEvent';
import { NachaPaymentInfo } from './NachaPaymentInfo';

export const CreateAdvancePaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createAdvancePayment'),
  payment: Payment,
  advanceId: FeeId,
  disableEmail: z.boolean().optional(),
  nachaPayment: NachaPaymentInfo.optional(),
});
export type CreateAdvancePaymentEvent = z.infer<typeof CreateAdvancePaymentEvent>;
